module.exports = __webpack_public_path__ + "media/images/badges/bft/milestone-250-active-bft-0d4d7830c8a7bea7e9edbea3acd8adeb.png";